import React from 'react';
import { TextField, FormHelperText, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import dayjs from 'dayjs';
import palette from 'src/theme/palette';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';

const CustomDatePicker = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  placeholder = '',
  fontFamily,
  marginBottom,
  sx,
  padding,
  margin,
  fontSize
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Typography
        sx={{
          fontSize: 12,
          marginBottom: '-3px',
          fontFamily: 'poppinsRegular',
          color: '#1a1a1a'
        }}
      >
        {label}
      </Typography>
      <DemoContainer
        components={['DatePicker']}
        sx={{ mb: error ? '0.2rem' : marginBottom ? marginBottom : '1rem', margin: margin }}
      >
        <DatePicker
          value={value ? dayjs(value) : null}
          onChange={onChange}
          onBlur={onBlur}
          format="MM/DD/YYYY"
          slotProps={{
            textField: {
              size: 'small',
              fullWidth: true,
              error,
              placeholder,
              sx: {
                ...sx,
                backgroundColor: '#fff',
                borderRadius: '6px',
                '& .MuiInputBase-input': {
                  fontSize: fontSize ? fontSize : 11,
                  fontFamily: fontFamily || 'poppinsRegular',
                  padding: padding ? padding : '12.3px 12px'
                },
                marginBottom: error ? '0.2rem' : marginBottom ? marginBottom : '1rem',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: palette.primary.inputborder,
                    borderWidth: '1.5px',
                    borderRadius: '6px'
                  },
                  '&:hover fieldset': {
                    borderColor: palette.primary.inputborder
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: palette.primary.inputborder
                  }
                }
              }
            },
            openPickerIcon: {
              sx: { fontSize: 18, color: palette.primary.dropdownArrow }
            }
          }}
          slots={{
            openPickerIcon: CalendarMonthIcon
          }}
        />
      </DemoContainer>
      {helperText && error && (
        <FormHelperText
          sx={{
            fontSize: 11,
            color: '#FF4842',
            fontFamily: 'poppinsRegular',
            marginLeft: 0
          }}
        >
          {helperText}
        </FormHelperText>
      )}
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
